import { render } from "./Telematics.vue?vue&type=template&id=5bf08200"
import script from "./Telematics.vue?vue&type=script&lang=js"
export * from "./Telematics.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__